/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { OrgEnrichmentResponseSize } from './orgEnrichmentResponseSize';

export interface OrgEnrichmentResponse {
  name?: string | null;
  domain?: string | null;
  logo_url?: string | null;
  size?: OrgEnrichmentResponseSize;
}
